import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import 'rxjs/add/observable/of';
import { environment } from '../../environments/environment';
var CategoryService = /** @class */ (function () {
    function CategoryService(http, localSt) {
        this.http = http;
        this.localSt = localSt;
        this.serverUrl = environment.serverUrl;
        this.serviceUrl = 'categories';
    }
    // list(data): Observable<any> {
    //   let reqObj = `?page=${data.page}&limit=${data.limit}&order=${data.order}`;
    //   if (data.search) {
    //     reqObj += '&search=${data.search}';
    //   }
    //   if (data.sort) {
    //     reqObj += '&sort=${data.sort}';
    //   }
    //   return this.http.get(this.serverUrl + this.serviceUrl + reqObj);
    // }
    CategoryService.prototype.list = function (data) {
        return this.http.put(this.serverUrl + 'categories/withactivefeatures', { date: data.date });
    };
    CategoryService.prototype.aboutUs = function () {
        return this.http.get(this.serverUrl + 'aboutus');
    };
    return CategoryService;
}());
export { CategoryService };



// WEBPACK FOOTER //
// ./src/app/services/category.service.ts.pre-build-optimizer.js